import styled from 'styled-components';
import { fontWeight, suisseIntl } from '../typography';

export const FooterRoot = styled.footer`
  background-color: #172436;
  color: #ffffff;
  contain: layout style;
  width: 100%;
  padding: 60px 32px;

  @media (min-width: 1176px) {
    padding: 60px 40px 100px;
  }
`;

export const Container = styled.div`
  margin: 0 auto;
  max-width: 1280px;
  width: 100%;

  @media (min-width: 1176px) {
    padding: 0 24px;
  }
`;

export const LegalSection = styled.div`
  width: 100%;
`;

export const LinkGroup = styled.nav`
  display: flex;
  flex-wrap: wrap;
  column-gap: 16px;
  row-gap: 8px;
  margin-bottom: 24px;
`;

export const FooterLink = styled.a`
  ${suisseIntl(fontWeight.regular)};
  color: #ffffff;
  font-size: 14px;
  line-height: 1.3;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.12em;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.85;
  }

  &:focus-visible {
    border-radius: 2px;
    outline: 2px solid #ffffff;
    outline-offset: 2px;
  }
`;

export const Text = styled.p`
  ${suisseIntl(fontWeight.regular)};
  color: #ffffff;
  font-size: 14px;
  line-height: 1.3;
  margin: 0 0 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const PhoneNumber = styled.a`
  color: #ffffff;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.12em;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.85;
  }

  &:focus-visible {
    border-radius: 2px;
    outline: 2px solid #ffffff;
    outline-offset: 2px;
  }
`;
